import React, { useState } from 'react';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { MdOutlineDownloadDone } from 'react-icons/md';

import './todo-task-list.css';

const TodoTaskList = ({ todoTaskData, handleDeleteItem }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [itemEditId, setItemEditId] = useState(null);
  const [editTask, setEditTask] = useState('');
  const handleEditTask = (item) => {
    setIsEdit(true);
    setItemEditId(item.id);
  };
  const handleEditDoneTask = (item) => {
    setIsEdit(false);
    setItemEditId('');
    todoTaskData.map((element) => {
      if (element.id === itemEditId) {
        return (element.task = editTask ? editTask : element.task);
      }
    });
  };
  const editTaskOnchange = (e) => {
    setEditTask(e.target.value);
  };
  return (
    <div>
      {todoTaskData.length > 0 &&
        todoTaskData.map((item) => {
          return (
            <div>
              {item.id !== itemEditId ? (
                <div className="toto-list-item" key={item.id}>
                  {item.task}
                </div>
              ) : (
                <div>
                  <input defaultValue={item.task} onChange={editTaskOnchange} />
                  <div>
                    <MdOutlineDownloadDone
                      onClick={() => handleEditDoneTask(item)}
                      size={30}
                    />
                  </div>
                </div>
              )}
              <div>
                {item.id !== itemEditId && (
                  <AiOutlineDelete
                    onClick={() => handleDeleteItem(item)}
                    size={30}
                  />
                )}
                {item.id !== itemEditId && (
                  <AiOutlineEdit
                    onClick={() => handleEditTask(item)}
                    size={30}
                  />
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default TodoTaskList;
